import React, { useEffect, useState } from 'react'
import Loader from 'react-loaders'
import AnimatedLetters from '../../AnimatedLetters'
import './index.scss'

const DreamsRetail = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <div className="container about-page">
        <div className="col s12 center-align">
          <h1 className={letterClass}>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={[
                'D',
                'r',
                'e',
                'a',
                'm',
                's',
                ' ',
                'R',
                'e',
                't',
                'a',
                'i',
                'l',
              ]}
              idx={15}
            />
          </h1>
        </div>

        <h3 className="experience-title">Dreams - Customer Advisor</h3>

        {/* Project Containers */}
        <div className="row project-container-wrapper">
          <div className="col s12 m6 project-container-1">
            <h4>• Surpassing KPI Targets & Driving Sales Growth</h4>
            <p>
              - Consistently exceeded KPI targets through the implementation of
              strategic sales techniques, tailored promotions, and upselling
              efforts.
            </p>
            <p>
              - Built lasting relationships with customers, enhancing customer
              loyalty and driving repeat business.
            </p>
            <p>
              - Contributed to store-wide sales objectives by identifying
              customer needs and offering product recommendations, resulting in
              increased sales and customer satisfaction.
            </p>
          </div>

          <div className="col s12 m6 project-container-2">
            <h4>• Team Leadership & Store Management</h4>
            <p>
              - Led store management initiatives, including staff scheduling,
              training, and performance evaluations, ensuring a well-coordinated
              and efficient team.
            </p>
            <p>
              - Motivated staff to maintain high levels of engagement and
              productivity through positive reinforcement and leading by
              example.
            </p>
            <p>
              - Oversaw the store’s visual merchandising, ensuring that product
              displays were appealing and aligned with brand standards,
              improving the overall shopping experience.
            </p>
          </div>

          <div className="col s12 m6 project-container-3">
            <h4>• Balancing Work & Academic Commitments</h4>
            <p>
              - Successfully worked as a customer advisor alongside university
              studies, managing both responsibilities effectively and achieving
              excellent results in both areas.
            </p>
            <p>
              - Developed strong time management skills, ensuring work and study
              commitments did not interfere with one another.
            </p>
            <p>
              - Demonstrated adaptability and resilience by balancing demanding
              customer-facing work with academic coursework, resulting in high
              performance in both environments.
            </p>
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default DreamsRetail
